<template>
<div>
  <el-row type="flex" class="title-bar" justify="space-between">
    <div class="vertical-center-box">
      <div class="title-h3 mr-r4">쓰레드</div>
      <el-button class="mr-l4" size="mini" @click="loadData"><i class="far fa-sync-alt"/></el-button>
    </div>
    <div>
      <el-button size="small" @click="exportThreadInfo"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px">  엑셀출력</el-button>
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </div>
  </el-row>
  <el-table-wrapper :data="tableData" v-loading="isLoading" :column-default="columnDefault" :columns="columns" :pagination="true"
   :total="threadTotalCount" :show-custom-header="true" :show-search-tool="showSearchTool" style="width:100%;">
   <template slot-scope="scope" slot="detail-slot">
    <span v-if="existTxid(scope.row)" class="c-pointer"><i class="far fa-search-plus" @click="showThreadPopup(scope.row)"/></span>
    </template>
  </el-table-wrapper>
  <w-thread-detail-popup ref="threadDetailPopup" :threadParams="threadParams" @reload="loadData"></w-thread-detail-popup>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil, cloneDeep, isEmpty } from 'lodash';
import { columnDefault } from '@/constants/table';
import moment from 'moment';
import { convertMillisecondsToSeconds } from '@/utils/number';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { calcUptime } from '@/utils/date';
import FileApi from '@/api/common/file';
import ApmConfigAPI from '@/api/config/apm/apm-info';
import WThreadDetailPopup from '../popup/ThreadDetailPopup';

export default {
  name: 'WThreadInfoNode',
  components: {
    WThreadDetailPopup,
  },
  props: {
    activeTab: {
      type: String,
    },
  },
  data() {
    return {
      columnDefault,
      threadTotalCount: 0,
      tableData: [],
      threadParams: {},
      isLoading: false,
      showSearchTool: false,
      params: {
        objId: null,
      },
      columns: [
        {
          prop: 'stat',
          label: '상태',
          width: 200,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'name',
          label: '이름',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'service',
          label: '서비스 이름',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'cpu',
          label: '쓰레드 CPU 시간 (s)',
          sortable: true,
          width: 230,
          searchable: false,
          formatter: this.convertValue,
        },
        {
          prop: 'elapsed',
          label: '경과 시간',
          sortable: true,
          width: 230,
          searchable: false,
          formatter: this.convertMillisecondsValue,
        },
        {
          label: '상세보기',
          width: 80,
          scopedSlot: 'detail-slot',
        },
      ],
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      handler() {
        if (!isNil(this.activeTab) && this.activeTab === 'WThreadInfoNode') {
          this.initData();
          this.loadData();
        }
      },
      immediate: true,
    },
    activeTab: {
      handler() {
        if (!isNil(this.activeTab) && this.activeTab === 'WThreadInfoNode') {
          this.initData();
          this.loadData();
        }
      },
    },
  },
  methods: {
    initData() {
      this.showSearchTool = false;
      this.tableData = [];
      this.threadTotalCount = 0;
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    loadData() {
      if (this.isLoading === false) {
        this.isLoading = true;
      }
      ApmConfigAPI.getThreadList({ objId: this.selectedNode.obj.objId }).then((response) => {
        if (response.data.success) {
          if (Object.entries(response.data.data).length > 0) {
            this.tableData = response.data.data.values;
            this.threadTotalCount = response.data.data.values.length;
          } else {
            this.tableData = [];
          }
          this.isLoading = false;
        }
      });
    },
    /**
     * [convertValue 시간 계산을 위한 converter]
     * @author yelim
     */
    convertValue(row, column, value) {
      if (value > 0) {
        const convertTime = moment();
        const substarctTargetTime = moment();
        substarctTargetTime.year(1970).month(0).date(1);
        substarctTargetTime.hours(0).minutes(0).seconds(0).milliseconds(0);
        convertTime.year(1970).month(0).date(1);
        convertTime.hours(0).minutes(0).seconds(value).milliseconds(0);

        return calcUptime(substarctTargetTime, convertTime);
      }
      return EMPTY_TEXT;
      // return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, null, true);
    },
    showThreadPopup(row) {
      this.threadParams = cloneDeep(row);
      this.$refs.threadDetailPopup.open();
    },
    existTxid(row) {
      if (row.txid !== null) {
        return true;
      }
      return false;
    },
    convertMillisecondsValue(row, column, value) {
      return convertMillisecondsToSeconds(value);
    },
    /**
     * [exportThreadInfo 성능/운영 > 구성 > 쓰레드 정보를 엑셀 출력한다.]
     * @author yelim
     */
    exportThreadInfo() {
      // 엑셀 데이터 있는지 확인하기
      if (!isNil(this.selectedNode)) {
        const threadParams = {
          objId: this.selectedNode.obj.objId,
        };
        ApmConfigAPI.getThreadInfoExcelName(threadParams).then((response) => {
          if (response.data.success && !isEmpty(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          }
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/config/node/apm/thread/index.vue